import Page from "./common/navigation/Page";
import Button from "./common/F7/Button";

import { useNavigate } from "react-router-dom";
import { FC, useCallback } from "react";
import { useSetJWT } from "../state";

const LogoutPage: FC = () => {
  const navigate = useNavigate();
  const setJwt = useSetJWT();

  const handleUserLogoutClick = useCallback(() => {
    setJwt(null);
    navigate("/");
  }, [setJwt, navigate]);

  return (
    <Page title="Logout">
      <Button onClick={handleUserLogoutClick}>Confirm logout</Button>
    </Page>
  );
};

export default LogoutPage;
